<template>
  <div id="app">
    <!-- Si estás en /paquetes, solo muestra el componente de la ruta -->
    <router-view v-if="esRutaPaquetes" />

    <!-- Si estás en otra ruta, muestra toda la invitación -->
    <div v-else>
      <div class="preload portada-1" />
      <div class="preload portada-2" />

      <Menubar />
      <InicioLogo />
      <Descripcion />
      <Navvar />
      <Eventosejemplo />
      <Paquetes />
      <Opiniones />
      <Footervue />
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';

import InicioLogo from './components/narvar.vue';
import Navvar from './components/navvar.vue';
import Menubar from './components/menubar.vue';
import Eventosejemplo from './components/eventosejemplo.vue';
import Descripcion from './components/descripcion.vue';
import Footervue from './components/footer.vue';
import Paquetes from './components/paquetes.vue';

export default {
  name: 'App',
  components: {
    InicioLogo,
    Navvar,
    Menubar,
    Eventosejemplo,
    Descripcion,
    Footervue,
    Paquetes,
  },
  setup() {
    const route = useRoute();
    const idInvitado = ref(Number(route.params.idInvitado) || undefined);
    const idFestejado = ref(Number(route.params.idFestejado) || undefined);

    const isValidIdInvitado = computed(() => !isNaN(idInvitado.value) && idInvitado.value !== undefined);
    const isValidFestejado = computed(() => !isNaN(idFestejado.value) && idFestejado.value !== undefined);

    const esRutaPaquetes = computed(() => route.name === 'paquetes'); // solo muestra router-view si estás en /paquetes

    watch(() => route.params.idInvitado, (newId) => {
      idInvitado.value = Number(newId);
    });

    watch(() => route.params.idFestejado, (newId) => {
      idFestejado.value = Number(newId);
    });

    return {
      idInvitado,
      idFestejado,
      isValidIdInvitado,
      isValidFestejado,
      esRutaPaquetes
    };
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
}

.preload {
  visibility: hidden;
  background-size: cover;
}

.preload.portada-1 {
  background-image: url('./assets/portada-1.webp');
}

@media (max-width: 768px) {
  #app {
    margin-top: 0px;
  }
}
</style>
